import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CryptoService } from './crypto.shared.service';

@Injectable({
    providedIn: 'root',
})
export class QueryParamsService {
    constructor(public cryptoService: CryptoService, public router: Router) {}

    public async clearQueryParams(...params): Promise<boolean> {
        const urlArr = window.location.href.split('?');
        if (!urlArr[1]) return false;
        let obj: { [key: string]: null } = null;

        if (!params || params.length === 0) {
            obj = urlArr[1].split('&').reduce((acc, param) => {
                acc[param.split('=')[0]] = null;

                return acc;
            }, {});
        } else {
            obj = params.reduce((acc, key) => {
                acc[key] = null;

                return acc;
            }, {});
        }

        if (Object.keys(obj).length) {
            return this.router.navigate([], {
                queryParams: obj,
                queryParamsHandling: 'merge',
            });
        }

        return false;
    }
}
